var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallIconcopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4718 12.6322L11.7288 13.363C9.20045 12.0844 7.63868 10.6157 6.72977 8.32624L7.42958 4.54398L6.10673 1H2.6975C1.67266 1 0.865636 1.8533 1.0187 2.87431C1.40081 5.42322 2.52747 10.0447 5.82086 13.363C9.27943 16.8477 14.2607 18.3599 17.0022 18.9609C18.0609 19.1931 19 18.3609 19 17.2693V13.9869L15.4718 12.6322Z",
    stroke: "#B8772A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIconcopy);
export default __webpack_public_path__ + "static/media/callIconcopy.1905807a2633d759a4cf37b1148621d4.svg";
export { ForwardRef as ReactComponent };